import React from 'react'
import cn from 'classnames'
import { observer } from 'mobx-react'

import Button, { IProps as ButtonProps } from 'components/button/Button'

import styles from './iconButton.scss'

interface IProps {
  className?: string
  children: ButtonProps['children']
  onClick: ButtonProps['onClick']
}

const IconButton = ({ className, children, onClick, ...others }: IProps) => (
  <Button
    className={cn(styles.container, className)}
    onClick={onClick}
    {...others}
  >
    {children}
  </Button>
)

export default observer(IconButton)
